import React, {createContext} from 'react';
export const InsuranceContext = createContext();